<script setup lang="ts">
const props = defineProps<{
  address: gen.BuyerAddressFragment | None | gen.BuyerCompanyAddressFragment
}>()

const ui = computed(() => {
  const address = props.address

  return {
    iso2: address?.country?.iso2,
    name: address && '_fullname' in address && address?._fullname ? address?._fullname : address && 'name' in address ? helpers.joinString(' ', address.name, address.lastname) : undefined,
    address: helpers.joinString(', ', address?.street, address?.apartment, address?.city, address?.postCode, address?.state),
    tel: address?.tel,
    four: address && 'deliveryInstruction' in address ? address?.deliveryInstruction : undefined,
  }
})
</script>

<template>
  <div class="_col _align-start _fs09 _gap02 _hm64 _lh12">
    <div class="_row _ctry _wrap _gap12">
      <h4 v-if="ui.name" class="_wm70ch">{{ ui.name }}</h4>
      <UiCountry :country="address?.country" />
    </div>
    <div v-if="ui.address" class="_label">{{ ui.address }}</div>
    <div v-if="ui.tel" class="_label">{{ ui.tel }}</div>
    <div v-if="ui.four" class="_italic">{{ ui.four }}</div>
  </div>
</template>
